import { Button as MaterialButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ExportButton } from '../components/common';
import FounderInviteModal from '../components/common/founder-invite-modal';
import FounderAssignModal from '../components/founders/founder-assign-modal';
import FounderProfileUpdateModal from '../components/founders/founder-profile-update-modal';
import FounderArchiveModal from '../components/founders/founders-archive-modal';
import Actions from '../components/layout/actions';
import BaseLayout from '../components/layout/base-layout';
import FoundersList from '../components/lists/founders-list';
import FoundersTable from '../components/tables/founders-table';
import {
  FoundersProvider,
  useFoundersContext,
} from '../contexts/founders-context';
import { UserContext } from '../contexts/user-context';
import { Pages } from '../router/constants';
import { ProtectedRouteProps } from '../router/type';
import { isMobile } from '../utils/functions';
import { CLASS_TRACKING } from '../utils/tracking_class';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
    padding: '0 20px !important',
    [theme.breakpoints.up('xs')]: {
      padding: 0,
      marginBottom: 25,
    },
    '& h2': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '22px',
        lineHeight: '40px',
      },
    },
  },
}));

function Founders({ user }: ProtectedRouteProps) {
  const classes = useStyles();
  const { hasAccessToAction } = useContext(UserContext);
  const { inviteTargetFounderId, setInviteTargetFounderId } =
    useFoundersContext();

  return (
    <BaseLayout user={user} fullWidth hiddenFooter={isMobile()}>
      <div className={classes.header}>
        <Typography variant='h2'>Founders</Typography>
        <Actions
          actions={[
            {
              key: 'new-founder',
              label: 'New Founder',
              hidden: !hasAccessToAction('founder.create'),
              component: (
                <MaterialButton
                  className={CLASS_TRACKING.ENTITY_ACTION}
                  component={Link}
                  to={Pages.NEW_FOUNDER}
                  data-testid='button-new-founder'
                  startIcon={<AddIcon />}
                  variant='contained'
                  color='primary'>
                  Founder
                </MaterialButton>
              ),
            },
            {
              key: 'export',
              label: 'Export',
              hidden: !hasAccessToAction('founder.export') || isMobile(),
              component: <ExportButton alias='founder' />,
            },
          ]}
        />
      </div>
      <div>{isMobile() ? <FoundersList /> : <FoundersTable />}</div>
      <FounderArchiveModal />
      <FounderProfileUpdateModal />
      <FounderAssignModal />
      <FounderInviteModal
        open={!!inviteTargetFounderId}
        founderId={inviteTargetFounderId}
        onClose={() => setInviteTargetFounderId(null)}
      />
    </BaseLayout>
  );
}

function FoundersPage(props: ProtectedRouteProps) {
  return (
    <FoundersProvider>
      <Founders {...props} />
    </FoundersProvider>
  );
}

export default FoundersPage;
